var map = {
	"./Ball-0.9s-200px.svg": "H1ZP",
	"./big-icon-alert.svg": "BwwP",
	"./big-icon-eclipse.svg": "GK9/",
	"./big-icon-rising.svg": "6X8f",
	"./big-icon-unsupported.svg": "sCxp",
	"./cashflow-loader/arrows.svg": "SK4b",
	"./cashflow-loader/pyramid.svg": "rQyb",
	"./cashflow-loader/sun.svg": "zaGx",
	"./cashflow-loader/wave.svg": "zLNc",
	"./group@3x.jpg": "yTt3",
	"./header-bank-square-bottom.svg": "Piu6",
	"./header-bank-square-top.svg": "ZgUL",
	"./header-cc-square-top.svg": "0esI",
	"./header-green-bottom-square.svg": "An4z",
	"./header-green-top-square.svg": "/L6+",
	"./header-red-square-bottom.svg": "YaMT",
	"./header-red-square-top.svg": "Zdn8",
	"./icons/arrow-down.svg": "Il3R",
	"./icons/arrow-up.svg": "kDvE",
	"./icons/icon-add.svg": "NLQn",
	"./icons/icon-lock.svg": "FEyP",
	"./icons/icon-small-check.svg": "r2a7",
	"./icons/icon-small-lock.svg": "VSJa",
	"./icons/left-arrow.svg": "cYMB",
	"./icons/no-icon.svg": "WNQT",
	"./icons/play-btn.svg": "Ncgc",
	"./icons/shield-icon.svg": "H8K+",
	"./icons/shield_square.svg": "/TxZ",
	"./icons/whatsapp.svg": "DE4d",
	"./security-logos.png": "MVxt",
	"./security-top-image.svg": "LioP",
	"./spinner-big.svg": "+Us7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g+Pq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding ^\.\/.*$
// module id = g+Pq
// module chunks = 6